import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Helmet } from "react-helmet";
import { useSiteQuery } from "../hooks";

function Seo({
  description,
  metaTitle,
  title,
  noIndex = false,
  slug = "",
  schema = [],
  image = null,
  canonical,
}) {
  const getCanonicalSlug = (slug) => {
    if (!slug) return "";
    if (slug === "/") return "";
    return slug.endsWith("/") ? slug : `${slug}/`;
  };

  const canonicalSlug = getCanonicalSlug(slug);

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  );
  const { headerLogo } = useSiteQuery();
  const seoImage = noIndex ? headerLogo : image || headerLogo;

  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = title || site.siteMetadata?.title;
  const siteUrl = "https://digitup.com/";

  // Local Business Schema
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "DigitUp",
    "image": "https://digitup-revamp-phase-1.netlify.app/logo.png",
    "@id": "https://digitup-revamp-phase-1.netlify.app/",
    "url": "https://digitup-revamp-phase-1.netlify.app/",
    "telephone": "+91-9205987107",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Unit 0001, 13th Floor, Imperia Mindspace, Sector 62",
      "addressLocality": "Gurgaon",
      "addressRegion": "Haryana",
      "postalCode": "122005",
      "addressCountry": "IN",
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 28.40192373987639,
      "longitude": 77.08540799889947,
    },
    "review": {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": 4.3,
        "bestRating": 5,
      },
      "author": {
        "@type": "Person",
        "name": "Amit Verma"
    }
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00",
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Saturday", "Sunday"],
        "opens": "09:00",
        "closes": "18:00",
      },
    ],
    "sameAs": [
      "https://www.instagram.com/digitupindia/",
      "https://www.linkedin.com/company/digitupindia?trk=blended-typeahead/",
    ],
  };
  const isLocalBusinessPage = slug === "/" || slug === "contact-us";


  return (
    <Helmet
      htmlAttributes={{
        lang: "en",
      }}
      title={title}
      titleTemplate={defaultTitle}
      meta={[
        {
          name: `title`,
          content: defaultTitle,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: defaultTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: `${seoImage ? `https:${seoImage.file.url}` : null}`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ]}
    >
      {canonical !== false ? (
        <link rel="canonical" href={`${siteUrl}${canonicalSlug}`} />
      ) : (
        ""
      )}
      {schema && schema.length > 0
        ? schema.map((schema, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(schema)}
            </script>
          ))
        : null}
    { isLocalBusinessPage &&
    (

      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      )}

<script
    src="https://heatmap.digitq.in/scripts/loader.min.js"
    defer
  ></script>

    </Helmet>
  );
}

export default Seo;
